const STATUS = {
    idle: 'idle',
    pending: 'pending',
    success: 'success',
    error: 'error',
}

export default STATUS;
